import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssociateSearchModalComponent } from '../associate-search/associate-search-modal/associate-search-modal.component';
import { DotcomModalComponent } from './dotcom-modal/dotcom-modal.component';
import { Constants } from '../../modules/constants';
import { NavigationService } from '../../modules/common/navigation.service';
import { TranslateService } from '../../modules/translation/translate.service';
import { BaseComponent } from '../common/page/base.component';
import { LocaleService } from '../common/locale/locale.service';
import { PageStructureService } from '../common/page-structure/page-structure.service';
import { TranslationMapperService } from '../common/translation-mapper.service';

@Component({
    selector: 'u-dotcom-footer',
    templateUrl: './dotcom-footer.component.html',
    styleUrls: ['./dotcom-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    animations: [
        trigger('fadeInFooter', [
            state('shown', style({ opacity: 1 })),
            state('hidden', style({ opacity: 0 })),
            transition('hidden => shown', animate('.5s')),
        ]),
    ],
})
export class DotcomFooterComponent extends BaseComponent implements OnInit {
    showFooter = false;
    recaptchaMessage: SafeHtml;

    src = 'footer';
    map = {
        emailText: 'emailText',
        followText: 'followText',
        socialMedia: [
            { social: 'socialMedia.0.social', url: 'socialMedia.0.url' },
            { social: 'socialMedia.1.social', url: 'socialMedia.1.url' },
            { social: 'socialMedia.2.social', url: 'socialMedia.2.url' },
            { social: 'socialMedia.3.social', url: 'socialMedia.3.url' },
            { social: 'socialMedia.4.social', url: 'socialMedia.4.url' },
            { social: 'socialMedia.5.social', url: 'socialMedia.5.url' },
        ],
        followTextLocale: 'followTextLocale',
        socialMediaLocale: [
            { social: 'socialMediaLocale.0.social', url: 'socialMediaLocale.0.url' },
            { social: 'socialMediaLocale.1.social', url: 'socialMediaLocale.1.url' },
            { social: 'socialMediaLocale.2.social', url: 'socialMediaLocale.2.url' },
            { social: 'socialMediaLocale.3.social', url: 'socialMediaLocale.3.url' },
            { social: 'socialMediaLocale.4.social', url: 'socialMediaLocale.4.url' },
            { social: 'socialMediaLocale.5.social', url: 'socialMediaLocale.5.url' },
        ],
        disclaimer1: 'disclaimer1',
        disclaimer2: 'disclaimer2',
        disclaimer3: 'disclaimer3',
        disclaimer4: 'disclaimer4',
        disclaimer5: 'disclaimer5',
        cookiesettings: 'cookiesettings',
        adaPolicy: 'adaPolicy',
        copyright: 'copyright',
        footerExtra: 'footerExtra',
        legal: [
            { url: 'legal.0.url', name: 'legal.0.name', target: 'legal.0.target' },
            { url: 'legal.1.url', name: 'legal.1.name', target: 'legal.1.target' },
            { url: 'legal.2.url', name: 'legal.2.name', target: 'legal.2.target' },
            { url: 'legal.3.url', name: 'legal.3.name', target: 'legal.3.target' },
            { url: 'legal.4.url', name: 'legal.4.name', target: 'legal.4.target' },
        ],
        items: [
            {
                name: 'items.0.name',
                children: [
                    { url: 'items.0.children.0.url', name: 'items.0.children.0.name', target: 'items.0.children.0.target' },
                    { url: 'items.0.children.1.url', name: 'items.0.children.1.name', target: 'items.0.children.1.target' },
                    { url: 'items.0.children.2.url', name: 'items.0.children.2.name', target: 'items.0.children.2.target' },
                    { url: 'items.0.children.3.url', name: 'items.0.children.3.name', target: 'items.0.children.3.target' },
                    { url: 'items.0.children.4.url', name: 'items.0.children.4.name', target: 'items.0.children.4.target' },
                    { url: 'items.0.children.5.url', name: 'items.0.children.5.name', target: 'items.0.children.5.target' },
                    { url: 'items.0.children.6.url', name: 'items.0.children.6.name', target: 'items.0.children.6.target' },
                    { url: 'items.0.children.7.url', name: 'items.0.children.7.name', target: 'items.0.children.7.target' },
                    { url: 'items.0.children.8.url', name: 'items.0.children.8.name', target: 'items.0.children.8.target' },
                    { url: 'items.0.children.9.url', name: 'items.0.children.9.name', target: 'items.0.children.9.target' },
                    { url: 'items.0.children.10.url', name: 'items.0.children.10.name', target: 'items.0.children.10.target' },
                    { url: 'items.0.children.11.url', name: 'items.0.children.11.name', target: 'items.0.children.11.target' },
                    { url: 'items.0.children.12.url', name: 'items.0.children.12.name', target: 'items.0.children.12.target' },
                ],
            },
            {
                name: 'items.1.name',
                children: [
                    { url: 'items.1.children.0.url', name: 'items.1.children.0.name', target: 'items.1.children.0.target' },
                    { url: 'items.1.children.1.url', name: 'items.1.children.1.name', target: 'items.1.children.1.target' },
                    { url: 'items.1.children.2.url', name: 'items.1.children.2.name', target: 'items.1.children.2.target' },
                    { url: 'items.1.children.3.url', name: 'items.1.children.3.name', target: 'items.1.children.3.target' },
                    { url: 'items.1.children.4.url', name: 'items.1.children.4.name', target: 'items.1.children.4.target' },
                    { url: 'items.1.children.5.url', name: 'items.1.children.5.name', target: 'items.1.children.5.target' },
                    { url: 'items.1.children.6.url', name: 'items.1.children.6.name', target: 'items.1.children.6.target' },
                    { url: 'items.1.children.7.url', name: 'items.1.children.7.name', target: 'items.1.children.7.target' },
                    { url: 'items.1.children.8.url', name: 'items.1.children.8.name', target: 'items.1.children.8.target' },
                    { url: 'items.1.children.9.url', name: 'items.1.children.9.name', target: 'items.1.children.9.target' },
                    { url: 'items.1.children.10.url', name: 'items.1.children.10.name', target: 'items.1.children.10.target', action: 'items.1.children.10.action' },
                    { url: 'items.1.children.11.url', name: 'items.1.children.11.name', target: 'items.1.children.11.target', action: 'items.1.children.11.action' },
                    { url: 'items.1.children.12.url', name: 'items.1.children.12.name', target: 'items.1.children.12.target', action: 'items.1.children.12.action' },
                ],
            },
            {
                name: 'items.2.name',
                children: [
                    { url: 'items.2.children.0.url', name: 'items.2.children.0.name', target: 'items.2.children.0.target' },
                    { url: 'items.2.children.1.url', name: 'items.2.children.1.name', target: 'items.2.children.1.target' },
                ],
            },
        ],
    };

    linkActionsMap = {
        openAssociateSearch: this.openAssociateSearchModal.bind(this),
        openIndiaGrievancesModal: this.openIndiaGrievancesModal.bind(this),
    };

    public isCollapsed = [true, true, true];

    constructor(
        protected http: HttpClient,
        localeService: LocaleService,
        titleService: Title,
        metaService: Meta,
        translationMapperService: TranslationMapperService,
        pageStructureService: PageStructureService,
        el: ElementRef,
        private readonly modalService: NgbModal,
        private readonly navigationService: NavigationService,
        private readonly cartTranslateService: TranslateService,
        private readonly sanitizer: DomSanitizer,
    ) {
        super(http, localeService, titleService, metaService, translationMapperService, el);
        pageStructureService.setFooterStructure({ src: this.src, map: this.map });
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.delayedShowFooter();

        this.navigationService.navigationStartSubject.watch().subscribe(() => {
            this.showFooter = false;
            this.delayedShowFooter();
        });

        this.cartTranslateService.translateRequest({
            tag: 'cart.footer.recaptcha.message',
            replacements: new Map([['privacyUrl', Constants.RECAPTCHA_PRIVACY], ['termsUrl', Constants.RECAPTCHA_TERMS]]),
        }).then((translatedValue) => this.recaptchaMessage = this.sanitizer.bypassSecurityTrustHtml(translatedValue));
    }

    private delayedShowFooter(): void {
        setTimeout(() => {
            this.showFooter = true;
        }, 1500);
    }

    onFooterLinkClicked(child: any): void {
        if (child && this.linkActionsMap[child.action]) {
            this.linkActionsMap[child.action]();
        }
    }

    openIndiaGrievancesModal(): void {
        const modalRef = this.modalService.open(DotcomModalComponent);
        modalRef.componentInstance.src = 'grievances-modal';
    }

    openAssociateSearchModal(): void {
        this.modalService.open(AssociateSearchModalComponent, { windowClass: 'dotcom-side-modal' });
    }
}
